module.exports = "/_next/static/images/1c90ebaa244be97719f6c5125907be82-girl-with-card-xs.png.webp";